<template>
   <div id="app">
      <router-view/>
   </div>
</template>

<script>
export default {
   name: 'app',
   data () {
      return {
         msg: 'Mobkast - Elevate the ordinary.'
      }
   }   
}
</script>


<style>
/* Landing Page */

/* Apps */
#app {
   font-family: 'Avenir', Helvetica, Arial, sans-serif;
   -webkit-font-smoothing: antialiased;
   -moz-osx-font-smoothing: grayscale;
   cursor: default;
}

.pointer { 
   cursor: pointer; 
}

body {
   background-color: #fdfdfd; /* Color background light white */
   min-width: 240px;
   margin: 0px;
}

.italicize {
   font-style: italic;
}

.bold {
   font-weight: bold;
}

::-webkit-scrollbar {
   display: none;
}

.scroll-container {
   overflow-y: auto;
   overflow-x: hidden;
   height: auto;
}

.no-scroll-container {
   overflow: hidden;
}

/* Colors */
.grey-out {
   color: #777777; /* COLOR GREY OUT */
}

.cpa-bk-grey {
   background-color: #EEEEEE; /* COLOR LIGHT GREY */
}

.cpa-bk-orange {
   background-color: #FFE8D7; /* COLOR LIGHT ORANGE */
}

/* Grid and Edit */
.cell-editable {
   cursor: cell;
   width: 100%;
   height: 100%;
}

.editable {
   cursor: crosshair;
}

/* UI Common */
.show {
    display: block !important;
}

.hide {
   display: none !important;
}


h1, h2 {
   font-weight: normal;
}

h2 {
   font-weight: normal;
   font-size: 1.6em;
}

</style>



// WEBPACK FOOTER //
// src/App.vue